/* eslint-disable no-case-declarations */
import { combineReducers } from 'redux';
import { IMMEDIATE } from '@quantiply/common/constants';
import {
  FETCH_ALGOS_REQUEST,
  FETCH_ALGOS_SUCCESS,
  FETCH_ALGOS_FAILURE,
  FETCH_ALGO_BY_ID_REQUEST,
  FETCH_ALGO_BY_ID_SUCCESS,
  FETCH_ALGO_BY_ID_FAILURE,
  ALGO_ADD_LEG,
  ALGO_TOGGLE_MATCH_PREMIUM,
  ALGO_DELETE_LEG,
  ALGO_UPDATE_CONFIG,
  ALGO_TOGGLE_TRANSACTIONTYPE,
  ALGO_TOGGLE_SIDE,
  ALGO_CHANGE_QUANTITY,
  ALGO_CHANGE_STRIKE,
  ALGO_CHANGE_LEG_TARGET_TYPE,
  ALGO_CHANGE_LEG_STOPLOSS_TYPE,
  ALGO_CHANGE_LEG_TRAILING_STOPLOSS_TYPE,
  ALGO_CHANGE_LEG_TARGET_VALUE,
  ALGO_CHANGE_LEG_STOPLOSS_VALUE,
  ALGO_CHANGE_LEG_TRAILING_STOPLOSS_MOVE_BY_VALUE,
  ALGO_CHANGE_LEG_TRAILING_STOPLOSS_TRAIL_BY_VALUE,
  ALGO_TOGGLE_BASE_INSTRUMENT,
  ALGO_STATUS_UPDATE,
  ALGO_TOGGLE_SUCCESS,
  ALGO_UPDATE_STOPLOSS_TRAILING,
  ALGO_LEG_PRODUCT_TOGGLE,
  ALGO_CHANGE_LEG_WAIT_AND_TRADE_TYPE,
  ALGO_CHANGE_LEG_WAIT_AND_TRADE_RESET,
  ALGO_CHANGE_LEG_WAIT_AND_TRADE_VALUE,
  ALGO_CHANGE_PREMIUM,
  ALGO_CHANGE_LEG_PROPS,
  ALGO_CHANGE_LEG_TYPE_REENTRY,
  ALGO_CHANGE_LEG_VALUE_REENTRY,
  ALGO_CHANGE_LEG_REENTRY,
} from '../constants/ActionTypes';

const legReEntryChange = ({ state, action }) => {
  const { data } = state;
  const { configurations = {} } = data.data;
  let { legs = [] } = configurations;

  legs = legs.map((leg) => {
    if (leg.id === action.data.id) {
      if (!leg.reEntry) {
        leg.reEntry = {};
      }

      leg.reEntry.type = action.data.type;
      leg.reEntry.repeat = action.data.value;

      if (action.data.value === 'none') {
        delete leg.reEntry;
      }
    }

    return leg;
  });

  data.data.configurations = {
    ...configurations,
    legs,
  };

  return data;
};

const legReEntryTypeChange = ({ state, action }) => {
  const { data } = state;
  const { configurations = {} } = data.data;
  let { legs = [] } = configurations;

  legs = legs.map((leg) => {
    if (leg.id === action.data.id) {
      if (!leg.reEntry) {
        leg.reEntry = {};
      }

      leg.reEntry.type = action.data.value;

      if (action.data.value === 'none') {
        delete leg.reEntry;
      }
    }

    return leg;
  });

  data.data.configurations = {
    ...configurations,
    legs,
  };

  return data;
};

const legReEntryValueChange = ({ state, action }) => {
  const { data } = state;
  const { configurations = {} } = data.data;
  let { legs = [] } = configurations;

  legs = legs.map((leg) => {
    if (leg.id === action.data.id) {
      if (!leg.reEntry) {
        return leg;
      }

      leg.reEntry.repeat = action.data.value;
    }

    return leg;
  });

  data.data.configurations = {
    ...configurations,
    legs,
  };

  return data;
};

const list = (
  state = { data: {}, isFetching: false, errorMessage: null },
  action
) => {
  switch (action.type) {
    case FETCH_ALGOS_REQUEST:
      return { ...state, isFetching: true, errorMessage: null };
    case FETCH_ALGOS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: action.data.data,
      };
    case FETCH_ALGOS_FAILURE:
      return { ...state, isFetching: false, errorMessage: action.message };
    case ALGO_TOGGLE_SUCCESS:
      // Read currunt state
      const curruntStateToggle = state && state.data ? state.data : {};
      // get currunt data (list of algos)
      let { data: algosToggle = [] } = curruntStateToggle;

      // check which algo is updated
      algosToggle = algosToggle.map((algo) => {
        if (action.data.id !== algo._id) {
          return algo;
        }

        algo.enabled = !algo.enabled;

        return algo;
      });

      // assign updated algolist
      state.data.data = algosToggle;

      return state;
    case ALGO_STATUS_UPDATE:
      // skip if page other than algos
      const url = window.location.href;
      const algoId = url.substring(url.lastIndexOf('/') + 1);
      if (algoId !== 'algos') {
        return state;
      }

      // Read currunt state
      const curruntState = state && state.data ? state.data : {};
      // get currunt data (list of algos)
      let { data: algos = [] } = curruntState;

      // check which algo is updated
      algos = algos.map((algo) => {
        if (action.data.algo !== algo._id) {
          return algo;
        }

        algo.status = action.data.status;

        return algo;
      });

      // assign updated algolist
      state.data.data = algos;

      return {
        ...state,
      };
    default:
      return state;
  }
};

const selected = (
  state = { data: {}, isFetching: false, errorMessage: null },
  action
) => {
  switch (action.type) {
    case FETCH_ALGO_BY_ID_REQUEST:
      return { ...state, isFetching: true, errorMessage: null };
    case FETCH_ALGO_BY_ID_SUCCESS:
      const { configurations: configurationsFetch = {} } =
        action.data.data.data;

      action.data.data.data.configurations = configurationsFetch;

      if (configurationsFetch.legs && configurationsFetch.legs.length) {
        const legsAdjusted = configurationsFetch.legs.map((cflegs) => {
          const modLegs = cflegs;

          if (!modLegs.product) {
            modLegs.product =
              cflegs.transactionType && cflegs.transactionType === 'S'
                ? 'I'
                : 'D';
          }

          return modLegs;
        });

        action.data.data.data.configurations.legs = legsAdjusted;
      }

      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: action.data.data,
      };
    case FETCH_ALGO_BY_ID_FAILURE:
      return { ...state, isFetching: false, errorMessage: action.message };
    case ALGO_ADD_LEG:
      const { data: dataAddLeg = {} } = state;
      const { configurations: configurationsAddLeg = {} } = dataAddLeg.data;
      const { legs: legsAddLeg = [] } = configurationsAddLeg;

      // console.log(configurationsAddLeg);

      legsAddLeg.push(action.data);
      dataAddLeg.data.configurations = {
        ...configurationsAddLeg,
        legs: legsAddLeg,
      };

      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: dataAddLeg,
      };
    case ALGO_TOGGLE_MATCH_PREMIUM:
      const { data: dataToggleMatchPremium = {} } = state;
      const { configurations: configurationsToggleMatchPremium = {} } =
        dataToggleMatchPremium.data;
      let { legs: legsToggleMatchPremium = [] } =
        configurationsToggleMatchPremium;
      const matchPremiumLength = legsToggleMatchPremium.filter((leg) => leg.mp);

      legsToggleMatchPremium = legsToggleMatchPremium.map((leg) => {
        if (leg.id === action.data) {
          if (matchPremiumLength.length < 2) {
            leg.mp = !leg.mp;
          } else {
            leg.mp = false;
          }
        }

        return leg;
      });

      dataToggleMatchPremium.data.configurations = {
        ...configurationsToggleMatchPremium,
        legs: legsToggleMatchPremium,
      };

      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: dataToggleMatchPremium,
      };
    case ALGO_TOGGLE_TRANSACTIONTYPE:
      const { data: dataToggleTransactionType = {} } = state;
      const { configurations: configurationsToggleTransactionType = {} } =
        dataToggleTransactionType.data;
      let { legs: legsToggleTransactionType = [] } =
        configurationsToggleTransactionType;

      legsToggleTransactionType = legsToggleTransactionType.map((leg) => {
        if (leg.id === action.data) {
          leg.transactionType = leg.transactionType === 'B' ? 'S' : 'B';
        }

        return leg;
      });

      dataToggleTransactionType.data.configurations = {
        ...configurationsToggleTransactionType,
        legs: legsToggleTransactionType,
      };

      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: dataToggleTransactionType,
      };
    case ALGO_TOGGLE_BASE_INSTRUMENT:
      const { data: dataToggleBaseInstrument = {} } = state;
      const { configurations: configurationsToggleBaseInstrument = {} } =
        dataToggleBaseInstrument.data;
      let { legs: legsToggleBaseInstrument = [] } =
        configurationsToggleBaseInstrument;

      legsToggleBaseInstrument = legsToggleBaseInstrument.map((leg) => {
        if (leg.id === action.data) {
          leg.base = leg.base === 'BANKNIFTY' ? 'NIFTY' : 'BANKNIFTY';
        }

        return leg;
      });

      dataToggleBaseInstrument.data.configurations = {
        ...configurationsToggleBaseInstrument,
        legs: legsToggleBaseInstrument,
      };

      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: dataToggleBaseInstrument,
      };
    case ALGO_TOGGLE_SIDE:
      const { data: dataToggleSide = {} } = state;
      const { configurations: configurationsToggleSide = {} } =
        dataToggleSide.data;
      let { legs: legsToggleSide = [] } = configurationsToggleSide;

      legsToggleSide = legsToggleSide.map((leg) => {
        if (
          leg.id === action.data.id &&
          action.data.side &&
          action.data.side !== ''
        ) {
          leg.side = action.data.side === 'CE' ? 'PE' : 'CE';
        }

        return leg;
      });

      dataToggleSide.data.configurations = {
        ...configurationsToggleSide,
        legs: legsToggleSide,
      };

      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: dataToggleSide,
      };
    case ALGO_CHANGE_LEG_TARGET_TYPE:
      const { data: dataChnageLegTargetType = {} } = state;
      const { configurations: configurationsChnageLegTargetType = {} } =
        dataChnageLegTargetType.data;
      let { legs: legsChnageLegTargetType = [] } =
        configurationsChnageLegTargetType;

      legsChnageLegTargetType = legsChnageLegTargetType.map((leg) => {
        if (leg.id === action.data.id) {
          if (!leg.target) {
            leg.target = {};
          }
          leg.target.type = action.data.value;

          if (action.data.value === 'none') {
            delete leg.target;
          }
        }

        return leg;
      });

      dataChnageLegTargetType.data.configurations = {
        ...configurationsChnageLegTargetType,
        legs: legsChnageLegTargetType,
      };

      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: dataChnageLegTargetType,
      };
    case ALGO_CHANGE_LEG_STOPLOSS_TYPE:
      const { data: dataChnageLegStoplossType = {} } = state;
      const { configurations: configurationsChnageLegStoplossType = {} } =
        dataChnageLegStoplossType.data;
      let { legs: legsChnageLegStoplossType = [] } =
        configurationsChnageLegStoplossType;

      legsChnageLegStoplossType = legsChnageLegStoplossType.map((leg) => {
        if (leg.id === action.data.id) {
          if (!leg.stoploss) {
            leg.stoploss = {};
          }
          leg.stoploss.type = action.data.value;

          if (action.data.value === 'none') {
            delete leg.stoploss;
            delete leg.trailingStoploss;
            delete leg.reEntry;
          }
        }

        return leg;
      });

      dataChnageLegStoplossType.data.configurations = {
        ...configurationsChnageLegStoplossType,
        legs: legsChnageLegStoplossType,
      };

      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: dataChnageLegStoplossType,
      };
    case ALGO_CHANGE_LEG_TRAILING_STOPLOSS_TYPE:
      const { data: dataChnageLegTrailingStoplossType = {} } = state;
      const {
        configurations: configurationsChnageLegTrailingStoplossType = {},
      } = dataChnageLegTrailingStoplossType.data;
      let { legs: legsChnageLegTrailingStoplossType = [] } =
        configurationsChnageLegTrailingStoplossType;

      legsChnageLegTrailingStoplossType = legsChnageLegTrailingStoplossType.map(
        (leg) => {
          if (leg.id === action.data.id) {
            if (!leg.trailingStoploss) {
              leg.trailingStoploss = {};
            }
            leg.trailingStoploss.type = action.data.value;

            if (action.data.value === 'none') {
              delete leg.trailingStoploss;
            }
          }

          return leg;
        }
      );

      dataChnageLegTrailingStoplossType.data.configurations = {
        ...configurationsChnageLegTrailingStoplossType,
        legs: legsChnageLegTrailingStoplossType,
      };

      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: dataChnageLegTrailingStoplossType,
      };
    case ALGO_CHANGE_QUANTITY:
      const { data: dataChangeQauntity = {} } = state;
      const { configurations: configurationsChangeQauntity = {} } =
        dataChangeQauntity.data;
      let { legs: legsChangeQauntity = [] } = configurationsChangeQauntity;

      legsChangeQauntity = legsChangeQauntity.map((leg) => {
        if (leg.id === action.data.id) {
          leg.quantity = action.data.quantity;
        }

        return leg;
      });

      dataChangeQauntity.data.configurations = {
        ...configurationsChangeQauntity,
        legs: legsChangeQauntity,
      };

      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: dataChangeQauntity,
      };
    case ALGO_CHANGE_STRIKE:
      const { data: dataChangeStrike = {} } = state;
      const { configurations: configurationsChangeStrike = {} } =
        dataChangeStrike.data;
      let { legs: legsChangeStrike = [] } = configurationsChangeStrike;

      legsChangeStrike = legsChangeStrike.map((leg) => {
        if (leg.id === action.data.id) {
          leg.strike = action.data.strike;
        }

        return leg;
      });

      dataChangeStrike.data.configurations = {
        ...configurationsChangeStrike,
        legs: legsChangeStrike,
      };

      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: dataChangeStrike,
      };
    case ALGO_CHANGE_LEG_TARGET_VALUE:
      const { data: dataChangeLegTargetValue = {} } = state;
      const { configurations: configurationsChangeLegTargetValue = {} } =
        dataChangeLegTargetValue.data;
      let { legs: legsChangeLegTargetValue = [] } =
        configurationsChangeLegTargetValue;

      legsChangeLegTargetValue = legsChangeLegTargetValue.map((leg) => {
        if (leg.id === action.data.id) {
          leg.target.value = action.data.value;
        }

        return leg;
      });

      dataChangeLegTargetValue.data.configurations = {
        ...configurationsChangeLegTargetValue,
        legs: legsChangeLegTargetValue,
      };

      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: dataChangeLegTargetValue,
      };
    case ALGO_CHANGE_LEG_STOPLOSS_VALUE:
      const { data: dataChangeLegStoplossValue = {} } = state;
      const { configurations: configurationsChangeLegStoplossValue = {} } =
        dataChangeLegStoplossValue.data;
      let { legs: legsChangeLegStoplossValue = [] } =
        configurationsChangeLegStoplossValue;

      legsChangeLegStoplossValue = legsChangeLegStoplossValue.map((leg) => {
        if (leg.id === action.data.id) {
          let value = Math.abs(action.data.value);

          value = -Math.abs(value);

          leg.stoploss.value = value;
        }

        return leg;
      });

      dataChangeLegStoplossValue.data.configurations = {
        ...configurationsChangeLegStoplossValue,
        legs: legsChangeLegStoplossValue,
      };

      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: dataChangeLegStoplossValue,
      };
    case ALGO_CHANGE_LEG_TRAILING_STOPLOSS_MOVE_BY_VALUE:
      const { data: dataChangeLegTrailingStoplossMoveByValue = {} } = state;
      const {
        configurations: configurationsChangeLegTrailingStoplossMoveByValue = {},
      } = dataChangeLegTrailingStoplossMoveByValue.data;
      let { legs: legsChangeLegTrailingStoplossMoveByValue = [] } =
        configurationsChangeLegTrailingStoplossMoveByValue;

      legsChangeLegTrailingStoplossMoveByValue =
        legsChangeLegTrailingStoplossMoveByValue.map((leg) => {
          if (leg.id === action.data.id) {
            leg.trailingStoploss.moveBy = action.data.value;
          }

          return leg;
        });

      dataChangeLegTrailingStoplossMoveByValue.data.configurations = {
        ...configurationsChangeLegTrailingStoplossMoveByValue,
        legs: legsChangeLegTrailingStoplossMoveByValue,
      };

      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: dataChangeLegTrailingStoplossMoveByValue,
      };
    case ALGO_CHANGE_LEG_TRAILING_STOPLOSS_TRAIL_BY_VALUE:
      const { data: dataChangeLegTrailingStoplossTrailByValue = {} } = state;
      const {
        configurations:
          configurationsChangeLegTrailingStoplossTrailByValue = {},
      } = dataChangeLegTrailingStoplossTrailByValue.data;
      let { legs: legsChangeLegTrailingStoplossTrailByValue = [] } =
        configurationsChangeLegTrailingStoplossTrailByValue;

      legsChangeLegTrailingStoplossTrailByValue =
        legsChangeLegTrailingStoplossTrailByValue.map((leg) => {
          if (leg.id === action.data.id) {
            leg.trailingStoploss.trailBy = action.data.value;
          }

          return leg;
        });

      dataChangeLegTrailingStoplossTrailByValue.data.configurations = {
        ...configurationsChangeLegTrailingStoplossTrailByValue,
        legs: legsChangeLegTrailingStoplossTrailByValue,
      };

      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: dataChangeLegTrailingStoplossTrailByValue,
      };
    case ALGO_CHANGE_LEG_REENTRY:
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: legReEntryChange({ state, action }),
      };
    case ALGO_CHANGE_LEG_TYPE_REENTRY:
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: legReEntryTypeChange({ state, action }),
      };
    case ALGO_CHANGE_LEG_VALUE_REENTRY:
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: legReEntryValueChange({ state, action }),
      };
    case ALGO_DELETE_LEG:
      const { data: dataDeleteLeg = {} } = state;
      const { configurations: configurationsDeleteLeg = {} } =
        dataDeleteLeg.data;
      let { legs: legsDeleteLeg = [] } = configurationsDeleteLeg;

      legsDeleteLeg = legsDeleteLeg.filter((leg) => leg.id !== action.data);

      dataDeleteLeg.data.configurations = {
        ...configurationsDeleteLeg,
        legs: legsDeleteLeg,
      };

      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: dataDeleteLeg,
      };
    case ALGO_UPDATE_CONFIG:
      const { data: dataUpdateConfig = {} } = state;

      dataUpdateConfig.data.configurations = action.data;

      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: dataUpdateConfig,
      };
    case ALGO_STATUS_UPDATE:
      const url = window.location.href;
      const algoId = url.substring(url.lastIndexOf('/') + 1);
      if (
        !action.data ||
        !action.data.algo ||
        algoId !== action.data.algo ||
        !action.data.status ||
        !state.data ||
        !state.data.data
      ) {
        return state;
      }

      const { data: dataStatusUpdate = {} } = state;

      if (!dataStatusUpdate.data.status) {
        dataStatusUpdate.data.status = '';
      }

      dataStatusUpdate.data.status = action.data.status;

      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: dataStatusUpdate,
      };
    case ALGO_UPDATE_STOPLOSS_TRAILING:
      const { data: dataUpdateStoplossTrailing = {} } = state;

      dataUpdateStoplossTrailing.data.stoplossTrailing =
        action.data.trailingState;

      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: dataUpdateStoplossTrailing,
      };
    case ALGO_LEG_PRODUCT_TOGGLE:
      const { data: dataAlgoLegProductToggle = {} } = state;
      const { configurations: configurationsAlgoLegProductToggle = {} } =
        dataAlgoLegProductToggle.data;
      let { legs: legsAlgoLegProductToggle = [] } =
        configurationsAlgoLegProductToggle;

      legsAlgoLegProductToggle = legsAlgoLegProductToggle.map((leg) => {
        if (leg.id === action.data.id) {
          leg.product = action.data.product;
        }

        return leg;
      });

      dataAlgoLegProductToggle.data.configurations = {
        ...configurationsAlgoLegProductToggle,
        legs: legsAlgoLegProductToggle,
      };

      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: dataAlgoLegProductToggle,
      };
    case ALGO_CHANGE_LEG_WAIT_AND_TRADE_TYPE:
      const { data: dataChnageLegWaitAndTrade = {} } = state;
      const { configurations: configurationsChnageLegWaitAndTrade = {} } =
        dataChnageLegWaitAndTrade.data;
      let { legs: legsChnageLegWaitAndTrade = [] } =
        configurationsChnageLegWaitAndTrade;

      legsChnageLegWaitAndTrade = legsChnageLegWaitAndTrade.map((leg) => {
        if (leg.id === action.data.id) {
          if (!leg.waitAndTrade) {
            leg.waitAndTrade = {};
          }
          leg.waitAndTrade.type = action.data.value;

          if (!leg.waitAndTrade.value) {
            leg.waitAndTrade.value = 0;
          }

          if (action.data.value === 'none') {
            leg.waitAndTrade.value = 0;
          }

          if (action.data.value === IMMEDIATE) {
            leg.waitAndTrade.value = 0;
          }
        }

        return leg;
      });

      dataChnageLegWaitAndTrade.data.configurations = {
        ...configurationsChnageLegWaitAndTrade,
        legs: legsChnageLegWaitAndTrade,
      };

      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: dataChnageLegWaitAndTrade,
      };
    case ALGO_CHANGE_LEG_WAIT_AND_TRADE_RESET:
      const { data: dataChnageLegWaitAndTradeRsest = {} } = state;
      const { configurations: configurationsChnageLegWaitAndTradeRsest = {} } =
        dataChnageLegWaitAndTradeRsest.data;
      let { legs: legsChnageLegWaitAndTradeRsest = [] } =
        configurationsChnageLegWaitAndTradeRsest;

      legsChnageLegWaitAndTradeRsest = legsChnageLegWaitAndTradeRsest.map(
        (leg) => {
          if (leg.waitAndTrade) {
            delete leg.waitAndTrade;
          }

          return leg;
        }
      );

      dataChnageLegWaitAndTradeRsest.data.configurations = {
        ...configurationsChnageLegWaitAndTradeRsest,
        legs: legsChnageLegWaitAndTradeRsest,
      };

      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: dataChnageLegWaitAndTradeRsest,
      };

    case ALGO_CHANGE_LEG_WAIT_AND_TRADE_VALUE:
      const { data: dataChangeLegWaitAndTradeValue = {} } = state;
      const { configurations: configurationsChangeLegWaitAndTradeValue = {} } =
        dataChangeLegWaitAndTradeValue.data;
      let { legs: legsChangeLegWaitAndTradeValue = [] } =
        configurationsChangeLegWaitAndTradeValue;

      legsChangeLegWaitAndTradeValue = legsChangeLegWaitAndTradeValue.map(
        (leg) => {
          if (!leg.waitAndTrade) {
            leg.waitAndTrade = {};
          }

          if (leg.id === action.data.id) {
            leg.waitAndTrade.value = action.data.value;
          }

          return leg;
        }
      );

      dataChangeLegWaitAndTradeValue.data.configurations = {
        ...configurationsChangeLegWaitAndTradeValue,
        legs: legsChangeLegWaitAndTradeValue,
      };

      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: dataChangeLegWaitAndTradeValue,
      };
    case ALGO_CHANGE_PREMIUM:
      const { data: dataPremium = {} } = state;
      const { configurations: configurationsPremium = {} } = dataPremium.data;
      let { legs: legsPremium = [] } = configurationsPremium;

      legsPremium = legsPremium.map((leg) => {
        if (leg.id === action.data.id && action.data.values) {
          if (action.data.values.type && action.data.values.type === 'STRIKE') {
            leg.selectionType = 'STRIKE';

            if (!leg.strike) {
              leg.strike = 'ATM';
            }

            if (leg.premium) {
              delete leg.premium;
            }
          } else {
            leg.selectionType = 'PREMIUM';

            if (leg.strike) {
              delete leg.strike;
            }

            if (!leg.premium) {
              leg.premium = {};
            }

            leg.premium = { ...leg.premium, ...action.data.values };

            if (!leg.premium.value) {
              leg.premium.value = 0;
            }
          }
        }

        return leg;
      });

      dataPremium.data.configurations = {
        ...configurationsPremium,
        legs: legsPremium,
      };

      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: dataPremium,
      };
    case ALGO_CHANGE_LEG_PROPS:
      const { data: dataChangeLegProps = {} } = state;
      const { configurations: configurationsChangeLegProps = {} } =
        dataChangeLegProps.data;
      let { legs: legsChangeLegProps = [] } = configurationsChangeLegProps;

      legsChangeLegProps = legsChangeLegProps.map((leg) => {
        if (leg.id !== action.data.id) {
          return leg;
        }

        if (!leg[action.data.name]) {
          leg[action.data.name] = '';
        }

        leg[action.data.name] = action.data.value;

        return leg;
      });

      dataChangeLegProps.data.configurations = {
        ...configurationsChangeLegProps,
        legs: legsChangeLegProps,
      };

      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: dataChangeLegProps,
      };
    default:
      return state;
  }
};

const algos = combineReducers({
  list,
  selected,
});

export default algos;
